import { render, staticRenderFns } from "./Tekshiruvchi.vue?vue&type=template&id=337e324c&scoped=true"
import script from "./Tekshiruvchi.vue?vue&type=script&lang=js"
export * from "./Tekshiruvchi.vue?vue&type=script&lang=js"
import style0 from "./Tekshiruvchi.vue?vue&type=style&index=0&id=337e324c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e324c",
  null
  
)

export default component.exports